import React, { useEffect } from "react";
import { useLocation } from "react-router-dom";

import { components } from "../components";
import { useTranslation } from "react-i18next";
import LanguageItem from "../components/profile/LanguageItem";

export const LanguageScreen: React.FC = () => {
  const { t, i18n } = useTranslation();
  const { pathname } = useLocation();

  useEffect(() => {
    const scrollToTop = () => {
      window.scrollTo(0, 0);
      document.documentElement.scrollTop = 0;
    };

    scrollToTop();
  }, [pathname]);

  const renderHeader = (): JSX.Element => {
    return <components.Header title={t("language")} goBack={true} />;
  };

  const onChangeLanguage = (ln: string) => {
    localStorage.setItem("language", ln);
    i18n.changeLanguage(ln);
  };

  return (
    <>
      {renderHeader()}
      <main style={{ paddingBottom: 0 }} className=" language">
        <LanguageItem
          onClick={() => onChangeLanguage("th")}
          title="ไทย"
          showTickIcon={i18n.language === "th"}
        />
        <LanguageItem
          onClick={() => onChangeLanguage("en")}
          title="EngLish"
          showTickIcon={i18n.language === "en"}
        />
      </main>
    </>
  );
};
